import React, { useEffect } from 'react';
import $i18n, { useI18n } from '@alife/panda-i18n';
import { logCustom } from 'src/utils/tracker';
import { PanelType } from 'src/types';
import './index.scss';
import { handleCustomMatchUrl, matchPageByUrl } from 'src/utils';
const matchQuestion = (pages, defaults, lang) => {
    const pathname = location.pathname;
    const includesPage = pages?.filter((p) => {
        // @ts-ignore
        return window.cnIntelliAssistantFilterUrl ? handleCustomMatchUrl(p?.pageUrl, pathname) : matchPageByUrl(p?.pageUrl, pathname);
    });
    if (includesPage?.length > 0) {
        return includesPage[0];
    }
    else {
        const defaultPage = defaults?.find((p) => p?.language === lang);
        return defaultPage;
    }
};
const CN = $i18n?.getLang() || 'zh-CN';
function setDefaultLanguage(list, lang = CN) {
    list?.forEach?.((item) => {
        if (!item.language) {
            item.language = lang;
        }
    });
}
export default function HelpCenter(props) {
    const { panelConfig, panelCode } = props;
    const $i18n = useI18n();
    const documentConfig = panelConfig?.find((m) => m?.panelConfigCode === PanelType.helpCenter);
    // 处理默认语言 兼容性未来可能出现的兼容问题
    setDefaultLanguage(documentConfig?.data?.pageHelpLink);
    setDefaultLanguage(documentConfig?.data?.defaultHelpLink);
    const currentLang = CN;
    const documentData = matchQuestion(documentConfig?.data?.pageHelpLink, documentConfig?.data?.defaultHelpLink, currentLang);
    useEffect(() => {
        if (documentData) {
            logCustom('EXP_helpCenter', documentData, panelCode);
        }
    }, []);
    const onClick = () => {
        window.open(documentData?.documentUrl);
        logCustom(`CLK_${documentConfig.panelConfigCode}`, documentData?.documentUrl, props.panelCode);
    };
    return documentData?.documentUrl ? (React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-help-center-img', onClick: onClick },
        React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-help-center-img-content' },
            React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-help-center-img-content-title' }, $i18n.get({ id: 'HelpCenter', dm: '帮助中心' })),
            React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-help-center-img-content-sub' }, $i18n.get({ id: 'HelpYouFindProblemsBetter', dm: '帮助您更好的查找问题' }))))) : null;
}
